import { styled } from "styled-components/macro";

export const EvidenceContainer = styled.div`
  display: flex;
  max-height: calc(100vh - 70px);
`;
